/**************************************************
 * Nombre:       Formulario_Producto_Variante_Ingreso
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import IngresoTexto from "../../../Modulo_formularios/Componentes/IngresoTexto";
import {ScaleOutlined} from "@mui/icons-material";
import IngresoDinero from "../../../Modulo_formularios/Componentes/IngresoDinero";

const Formulario_Producto_Variante_Ingreso = ({...props}) => {


    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >


                <Grid container size={6}>
                    <IngresoTexto Icono={ScaleOutlined} nombre={'Cantidad o Medida'}
                                  dato={'nombre'} {...props}
                                  requerido={'El Nombre es requerido'}
                    />
                </Grid>

                <Grid container size={6} sx={{justifyContent: 'flex-start'}}>

                </Grid>

                <Grid container size={6}>
                    <IngresoDinero nombre={'Valor'}
                                   dato={'valor'} {...props}
                                   requerido={'El Valor es requerido'}
                    />
                </Grid>

                <Grid container size={6}>
                    <IngresoDinero nombre={'Valor Con Descuento'}
                                   dato={'valorDescuento'} {...props}

                    />
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Producto_Variante_Ingreso